const state = {
  cardsList: []
}

const actions = {
  async getCardsList(context) {
    const list = await window.$httpService.card.getCardsList();
    context.commit('setCardsList', list.data);
  },
  async setDefaultCard(context, card_id) {
    try {
      const response = await window.$httpService.card.setDefaultCard(card_id);

      context.commit('setProfile', response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async deleteCard(context, card_id) {
    await window.$httpService.card.deleteCard(card_id)
  }
};

const mutations = {
  setCardsList(state, data) {
    state.cardsList = data;
  }
}

const getters = {
  cardsList(state) {
    return state.cardsList;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}